import { render, staticRenderFns } from "./Prematch.vue?vue&type=template&id=ed3b0e60&scoped=true"
import script from "./Prematch.vue?vue&type=script&lang=js"
export * from "./Prematch.vue?vue&type=script&lang=js"
import style0 from "./Prematch.vue?vue&type=style&index=0&id=ed3b0e60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3b0e60",
  null
  
)

export default component.exports